// src/modules/system/components/ErrorTrendChart.js
//
// Daily error-event volume. The data comes from the per-row daily_counts JSONB
// maps merged server-side (see stats endpoint) — because rows are deduped,
// there is no per-event table to aggregate, but the counts are still exact.
//
// recharts is already a dependency of this app (2.15.3); no new package.
import React from 'react';
import styled, { useTheme } from 'styled-components';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

const Wrap = styled.div`
  background: ${(p) => p.theme.colors.surface};
  border-radius: ${(p) => p.theme.borderRadius};
  padding: ${(p) => p.theme.spacing(3)};
  margin-bottom: ${(p) => p.theme.spacing(3)};
  box-shadow: 0 2px 4px rgba(0,0,0,.1);
  h3 { margin: 0 0 ${(p) => p.theme.spacing(2)}; font-size: 1rem;
       color: ${(p) => p.theme.colors.textPrimary}; font-weight: 600; }
`;

const shortDate = (iso) => {
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? iso : `${d.getMonth() + 1}/${d.getDate()}`;
};

const ErrorTrendChart = ({ data }) => {
  const theme = useTheme();
  if (!data || !data.length) return null;

  return (
    <Wrap>
      <h3>Error events per day</h3>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.colors.inputGray} vertical={false} />
          <XAxis dataKey="date" tickFormatter={shortDate} stroke={theme.colors.textSecondary} fontSize={12} />
          <YAxis allowDecimals={false} stroke={theme.colors.textSecondary} fontSize={12} />
          <Tooltip
            cursor={{ fill: `${theme.colors.primary}18` }}
            contentStyle={{
              background: theme.colors.background,
              border: `1px solid ${theme.colors.inputGray}`,
              borderRadius: 6,
              color: theme.colors.textPrimary,
            }}
            labelFormatter={(v) => v}
            formatter={(v) => [v, 'events']}
          />
          <Bar dataKey="count" fill={theme.colors.primary} radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Wrap>
  );
};

export default ErrorTrendChart;
